export const ROUTES = {
  ROOT: '/',
  LANDING: '/',
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  // Onboarding wizard 5 pasos.
  WIZARD: '/onboarding/wizard',
  // Catálogos.
  CUSTOMERS: '/clientes',
  CUSTOMER_NEW: '/clientes/nuevo',
  CUSTOMER_EDIT: '/clientes/:id',
  PRODUCTS: '/productos',
  PRODUCT_NEW: '/productos/nuevo',
  PRODUCT_EDIT: '/productos/:id',
  // Facturación.
  INVOICES: '/facturas',
  INVOICE_NEW: '/facturas/nueva',
  INVOICE_DETAIL: '/facturas/:id',
  // Reportes + settings.
  REPORTS: '/reportes',
  SETTINGS: '/configuracion',
  // Sub-páginas de settings editables.
  SETTINGS_PROFILE: '/configuracion/perfil',
  SETTINGS_RESOLUTION: '/configuracion/resolucion',
  // Registro de empresa (cuando memberships_count === 0).
  REGISTER_COMPANY: '/registrar-empresa',
  // Cuenta personal self-service del user.
  ACCOUNT: '/cuenta',
  ACCOUNT_SECURITY: '/cuenta/seguridad',
  ACCOUNT_PRIVACY: '/cuenta/privacidad',
  // Habilitación DIAN.
  HABILITACION: '/habilitacion',
} as const

// Set de pruebas de habilitación DIAN (md/985 §5.1 — datos asignados
// por DIAN al registrar "Software propio - PT" en MUISCA).
//
// Composición exigida: 30 facturas + 10 notas débito + 10 notas crédito
// TRANSMITIDAS a vpfe-hab. El umbral real de aprobación es 1 (una)
// factura ACEPTADA — el resto solo debe transmitirse, sin importar el
// resultado. El asistente backend automatiza los primeros documentos
// (10 FE + 1 NC + 1 ND).
export const DIAN_HABILITACION_SET = {
  INVOICES_TARGET: 30,
  DEBIT_NOTES_TARGET: 10,
  CREDIT_NOTES_TARGET: 10,
  MIN_ACCEPTED_INVOICES: 1,
  HELPER_INVOICES: 10,
} as const

export const APP = {
  name: import.meta.env.VITE_APP_NAME ?? 'Taxor Facturador',
  apiUrl: import.meta.env.VITE_API_URL ?? 'http://localhost:8400',
  accountUrl: import.meta.env.VITE_TAX_ACCOUNT_URL ?? 'http://localhost:8410',
  contactEmail: 'contacto@taxor.co',
} as const

// DIAN: códigos de responsabilidades fiscales (Anexo Técnico v1.9).
// Mostrados en wizard step "fiscal".
export const FISCAL_RESPONSIBILITIES = [
  { code: 'O-13', label: 'Gran contribuyente' },
  { code: 'O-15', label: 'Autorretenedor' },
  { code: 'O-23', label: 'Agente de retención IVA' },
  { code: 'O-47', label: 'Régimen Simple de Tributación (RST)' },
  // R-99-PN es el residual "No aplica / Otros" (DIAN Res. 000167) — NO
  // significa "no responsable de IVA" (ese es O-49). Lo usa el responsable
  // de IVA en régimen ordinario sin ninguna calidad especial.
  { code: 'R-99-PN', label: 'No aplica / Otros (sin responsabilidad especial)' },
] as const

// DIAN: regímenes tributarios.
export const TAX_REGIMES = [
  { code: '48', label: 'Responsable de IVA' },
  { code: '49', label: 'No responsable de IVA' },
] as const

// DIAN: códigos de identificación.
export const ID_TYPES = [
  { code: '11', label: '11 — Registro civil' },
  { code: '12', label: '12 — Tarjeta de identidad' },
  { code: '13', label: '13 — Cédula de ciudadanía' },
  { code: '21', label: '21 — Tarjeta de extranjería' },
  { code: '22', label: '22 — Cédula de extranjería' },
  { code: '31', label: '31 — NIT' },
  { code: '41', label: '41 — Pasaporte' },
  { code: '42', label: '42 — Documento de identificación extranjero' },
  { code: '50', label: '50 — NIT de otro país' },
  { code: '91', label: '91 — NUIP' },
] as const

// Departamentos COL (DIAN códigos DANE).
// Lista corta — completar en G.5 con datos full DANE.
export const DEPARTMENTS = [
  'Amazonas', 'Antioquia', 'Arauca', 'Atlántico', 'Bolívar', 'Boyacá',
  'Caldas', 'Caquetá', 'Casanare', 'Cauca', 'Cesar', 'Chocó',
  'Córdoba', 'Cundinamarca', 'Guainía', 'Guaviare', 'Huila', 'La Guajira',
  'Magdalena', 'Meta', 'Nariño', 'Norte de Santander', 'Putumayo', 'Quindío',
  'Risaralda', 'San Andrés y Providencia', 'Santander', 'Sucre',
  'Tolima', 'Valle del Cauca', 'Vaupés', 'Vichada', 'Bogotá D.C.',
] as const
